import { dateConverter, originalDateConverter } from '../dateConverter';
import * as moment from 'moment/moment';
import React from 'react';


export const EventTimeConvertor = ({ event }) => {


    return(
        <>
        {event?.timezoneOffset ? (
            <div>
                {event?.locationType === 'VIRTUAL' ? (
                    <p>
                        {event?.startTime ?
                            `${originalDateConverter(event)} ${event.timezoneOffset ? `(GMT ${event.timezoneOffset} )` : ''}`
                            :
                            `${moment(event.startDate).format('ll')} ${event?.allDay ? '(All Day)' : ''}`}
                    </p>
                ) : (
                    <p>
                        {event.startTime ?
                            `${dateConverter(event)} (Your Time)`
                            :
                            `${moment(event.startDate).format('ll')} ${event?.allDay ? '(All Day)' : ''}`}
                    </p>
                )}
            </div>
        ) : (
            <p>{`${moment(event?.startTime).format('llll')} ${
                event?.timezoneOffset ? `(GMT ${event?.timezoneOffset} )` : ''
            }`}</p>
        )}
        </>
    )
}